// extracted by mini-css-extract-plugin
module.exports = {"modal":"style_modal__2R4EJ","paper":"style_paper__3gnp-","content":"style_content__3UDou","title":"style_title__e3AKe","image":"style_image__lifM8"};